export const ESTADOSCAMPANYASTRING = {
  DESISTIDA: "Desistida",
  EN_CREACION: "En creación",
  EN_CURSO: "En curso",
  FINALIZADA: "Finalizada",
  NO_LANZADA: "No lanzada",
  PARADA: "Parada",
  SOLICITADA: "Solicitada"
} as const

export const ESTADOSCAMPANYASACCIONCAMPANYAS = {
  [ESTADOSCAMPANYASTRING.EN_CREACION]: "C",
  [ESTADOSCAMPANYASTRING.EN_CURSO]: "L",
  [ESTADOSCAMPANYASTRING.NO_LANZADA]: "N"
} as const

export type EstadosCampanyasAccionCampanyasType =
  (typeof ESTADOSCAMPANYAS)[keyof typeof ESTADOSCAMPANYASACCIONCAMPANYAS]

export const ESTADOSCAMPANYAS = {
  [ESTADOSCAMPANYASTRING.DESISTIDA]: "D",
  [ESTADOSCAMPANYASTRING.EN_CREACION]: "C",
  [ESTADOSCAMPANYASTRING.EN_CURSO]: "L",
  [ESTADOSCAMPANYASTRING.FINALIZADA]: "F",
  [ESTADOSCAMPANYASTRING.NO_LANZADA]: "N",
  [ESTADOSCAMPANYASTRING.PARADA]: "P",
  [ESTADOSCAMPANYASTRING.SOLICITADA]: "S"
} as const

export type EstadosCampanyasType =
  (typeof ESTADOSCAMPANYAS)[keyof typeof ESTADOSCAMPANYAS]

export const ALCANCEFILTROSATURACIONTRING = {
  ACCION_COMERCIAL: "Acción Comercial",
  CAMPANYA: "Campaña"
} as const

export const ALCANCEFILTROSATURACION = {
  [ALCANCEFILTROSATURACIONTRING.ACCION_COMERCIAL]: 1,
  [ALCANCEFILTROSATURACIONTRING.CAMPANYA]: 2
} as const

export type AlcanceFiltroSaturacionType =
  (typeof ALCANCEFILTROSATURACION)[keyof typeof ALCANCEFILTROSATURACION]

export const TIPOSFILTROSATURACIONTRING = {
  FICHERO: "Fichero",
  RESPUESTA_NEGATIVA: "Respusta negativa",
  CAMPANYA: "Campaña"
} as const

export const TIPOSFILTROSATURACION = {
  [TIPOSFILTROSATURACIONTRING.FICHERO]: "1",
  [TIPOSFILTROSATURACIONTRING.RESPUESTA_NEGATIVA]: "2",
  [TIPOSFILTROSATURACIONTRING.CAMPANYA]: "3"
} as const

export const TIPOSFILTROSATURACIONCONFIG = {
  [TIPOSFILTROSATURACION[TIPOSFILTROSATURACIONTRING.FICHERO]]: {
    editable: true
  },
  [TIPOSFILTROSATURACION[TIPOSFILTROSATURACIONTRING.RESPUESTA_NEGATIVA]]: {
    editable: false
  },
  [TIPOSFILTROSATURACION[TIPOSFILTROSATURACIONTRING.CAMPANYA]]: {
    editable: true
  }
} as const

export type TiposFiltroSaturacionConfigType =
  (typeof TIPOSFILTROSATURACIONCONFIG)[keyof typeof TIPOSFILTROSATURACIONCONFIG]

export type TiposFiltroSaturacionType =
  (typeof TIPOSFILTROSATURACION)[keyof typeof TIPOSFILTROSATURACION]

export const TIPOSSIMULACIONTRING = {
  PUBLICO_OBJETIVO: "Público objetivo",
  CONVERSION: "Conversión mínima",
  VENTAS: "Ventas mínimas",
  VOLUMEN: "Volumen de negocio"
} as const

export const TIPOSSIMULACION = {
  [TIPOSSIMULACIONTRING.PUBLICO_OBJETIVO]: "1",
  [TIPOSSIMULACIONTRING.CONVERSION]: "2",
  [TIPOSSIMULACIONTRING.VENTAS]: "3",
  [TIPOSSIMULACIONTRING.VOLUMEN]: "4"
} as const

export type TiposSimulacionType =
  (typeof TIPOSSIMULACION)[keyof typeof TIPOSSIMULACION]

export const FILTERTABS = {
  ACCION: "Acción",
  SATURACION: "Saturación",
  ADICIONALES: "Adicionales"
} as const

export const FILTERTABSCONFIG = {
  Propiedad: FILTERTABS.ADICIONALES,
  Saturación: FILTERTABS.SATURACION
} as const

export type FilterTabsType = (typeof FILTERTABS)[keyof typeof FILTERTABS]

export const ACTUALIZACIONINFOITEMSELECCIONADO = {
  FILTROS_ADICIONALES: "Filtros adicionales",
  FILTROS_SATURACION: "Filtro saturacion",
  FORMULA: "Formula",
  UNIVERSO: "Universo",
  CAMPANYA_INFO: "Campanya info"
} as const

export type ActualizacionInfoCampanyaSeleccionadaObjetoType =
  (typeof ACTUALIZACIONINFOITEMSELECCIONADO)[keyof typeof ACTUALIZACIONINFOITEMSELECCIONADO]

export const SCREEN_OPTIONS = {
  MODIFICAR_ACCION_COMERCIAL: "Modificar acción comercial",
  FILTROS_ACCION_COMERCIAL_HOME: "Filtros acción comercial home",
  SELECCIONAR_CAMPANYA: "Seleccionar campaña",
  CREATE_CAMPANYA: "Crear campaña",
  INFO_CASO_USO: "Info caso uso",
  EVENTS_PANEL: "panel lateral eventos",
  CONDICIONES_MANAGER: "Condiciones manager",
  ADD_CONDICIONES_CONVERSION: "Añadir condiciones conversion",
  SELECT_BIDATA_ENTITY: "Seleccionar entidad biData",
  FILTER_TIPOS_ACCION: "Filtros tipo accion",
  SHOW_EVENTS_PANEL_LATERAL: "panel lateral eventos",
  SHOW_NEW_USER_PANEL_LATERAL: "panel lateral usuarios",
  SHOW_PROFILE_PANEL_LATERAL: "panel lateral profile"
} as const

export type ScreenOptionsType =
  (typeof SCREEN_OPTIONS)[keyof typeof SCREEN_OPTIONS]

export const WIDTH_BUTTON_AI = {
  BC01: "80%",
  BC98: "80%",
  BC99: "80%",
  SP03: "100%",
  SP04: "80%"
}

export const SIN_DISTRIB_VARIABLES = {
    BC01:false
}

export const BLOQUES_EVENTS = {
  NUEVO_BLOQUE_INFO: "NUEVO_BLOQUE_INFO",
  GUARDAR_CAMPO: "GUARDAR_CAMPO",
  GUARDAR_EDGES: "GUARDAR_EDGES",
  UPDATE_CAMPO_BLOQUE: "UPDATE_CAMPO_BLOQUE",
  GO_BLOCK_FROM_BUTTON: "GO_BLOCK_FROM_BUTTON",
  UPDATE_VALORES_CUSTOMER: "UPDATE_VALORES_CUSTOMER",
  UPDATE_RELACIONES_BLOQUE: "UPDATE_RELACIONES_BLOQUE",
  UPDATE_CAMPO_BLOQUE_FORMULAS: "UPDATE_CAMPO_BLOQUE_FORMULAS",
  UPDATE_PATH_FICHERO_DOMINIOS: "UPDATE_PATH_FICHERO_DOMINIOS"
} as const

export const CHANGE_BLOQUE_ORIGIN = {
  BLOQUE: "BLOQUE",
  STEPPER: "STEPPER"
} as const

export const SIN_BIDATA = {
  SP03: true
}
